import brand from '@helpers/brand';
import { setCssVar } from '@helpers/cssVar';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('fgColor', brand.black)};

  .theme-hh & {
    ${setCssVar('fgColor', brand.white)};
  }

  .theme-apl & {
    ${setCssVar('fgColor', brand.black)};
  }

  display: flex;
`;
const ContentWrapper = styled.div `
  margin: 0 0 32px 0;
  position: relative;
  flex-basis: 100%;
  padding: 0px 10px;

  @media ${from(Device.TabletLarge)} {
    flex-basis: 50%;
  }

  [data-text-align='left'] & {
    text-align: left;
  }

  [data-text-align='right'] & {
    text-align: right;
  }

  [data-text-align='center'] & {
    text-align: center;
  }
`;
const Inner = styled.div `
  position: relative;
  overflow: hidden;
  height: 100%;
  justify-content: center;
  border-radius: 11px;
  display: flex;
  flex-wrap: wrap;

  @media ${from(Device.Tablet)} {
    border-radius: 24px;
  }
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles}
`;
export const FiftyFiftyTextStyles = {
    Container,
    ContentWrapper,
    Inner,
    Content,
};
